(() => {
  const linkSelector = '.jdgm-widget[data-product-review-url] .jdgm-prev-badge__text a';

  const syncHref = (event) => {
    const link = event.target instanceof Element && event.target.closest(linkSelector);
    if (!link) return;

    const reviewUrl = link.closest('[data-product-review-url]').dataset.productReviewUrl;
    if (link.getAttribute('href') !== reviewUrl) link.setAttribute('href', reviewUrl);
  };

  ['pointerover', 'focusin', 'touchstart', 'click'].forEach((type) => {
    document.addEventListener(type, syncHref, { capture: true, passive: true });
  });
})();
